export default function CookieBanner({ onAccept, onReject }) {
  return (
    <div className="fixed bottom-0 inset-x-0 z-[1000000000] px-4 pb-4">
      <div className="mx-auto bg-white max-w-6xl rounded-xl bg-slate-900 text-slate-100 shadow-2xl border border-slate-800">
        <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
          
          {/* Content */}
          <div className="max-w-3xl">
            <h4 className="text-base font-semibold text-primary">
              We value your privacy
            </h4>
            <p className="mt-1 text-sm text-slate-300 leading-relaxed">
              We use cookies to enhance your experience and for analytics &
              marketing purposes (such as Klaviyo). You can accept or reject
              non-essential cookies at any time.
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-shrink-0 items-center gap-3">
            <button
              onClick={onReject}
              className="rounded-lg border border-slate-700 px-4 py-2 text-sm font-medium text-slate-300 hover:bg-slate hover:text-slate-300 transition"
            >
              Reject
            </button>

            <button
              onClick={onAccept}
              className="rounded-lg bg-primary px-5 py-2 text-sm font-medium text-white hover:bg-primary/80 transition"
            >
              Accept cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
